import { atom } from 'recoil';

export const agentUserId = atom({
  key: 'agentUserId', // unique ID (with respect to other atoms/selectors)
  default: {
    id: '',
    name: '',
    systemTeamId: '',
    type: '',
  },
  // default value (aka initial value)
});
